import { useTranslation } from 'react-i18next'
import scrollToHeroEmbed from '../../utils/scrollToHeroEmbed'

const ServicesCtaSection = () => {
  const { t } = useTranslation()
  return (
    <section className="w-full bg-gradient-to-r from-[#040914] to-[#081226] text-white py-16 px-6 md:px-12 flex flex-col items-center">
      <div className="w-full max-w-4xl text-center space-y-4">
        <p className="text-xs uppercase tracking-[0.4em] text-pyramid-1">
          {t('services.cta_tag')}
        </p>
        <h2 className="text-3xl md:text-4xl font-black">
          {t('services.cta_heading')}
        </h2>
        <p className="text-lg text-slate-200">{t('services.cta_body')}</p>
        <button
          onClick={scrollToHeroEmbed}
          className="rounded-[8px] bg-gradient-to-r from-pyramid-1 via-pyramid-10 to-pyramid-19 px-6 py-3 font-semibold text-ebony shadow-lg shadow-pyramid-10/40"
        >
          {t('services.cta_demo')}
        </button>
        <p className="text-xs text-slate-400">{t('services.cta_disclaimer')}</p>
      </div>
    </section>
  )
}

export default ServicesCtaSection
